import { useState, useEffect, useCallback } from 'react';
import { supabase, isConfigured } from '../supabase/supabase';

const tableMapping = {
  trasteros: 'trasteros_20240520',
  clientes: 'clientes_20240520',
  reservas: 'reservas_20240520',
  pagos: 'pagos_20240520',
  incidencias: 'incidencias_20240520',
  codigos: 'codigos_acceso_20240520',
};

export const useDatabase = (tableName) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const realTableName = tableMapping[tableName] || tableName;

  const fetchData = useCallback(async () => {
    if (!isConfigured) {
      setError('Supabase no configurado. Añade VITE_SUPABASE_URL y VITE_SUPABASE_ANON_KEY en el archivo .env');
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const { data: result, error: supabaseError } = await supabase
        .from(realTableName)
        .select('*')
        .order('created_at', { ascending: false });

      if (supabaseError) throw supabaseError;
      setData(result || []);
    } catch (err) {
      setError(err.message);
      console.error(`Error cargando ${tableName}:`, err);
    } finally {
      setLoading(false);
    }
  }, [realTableName, tableName]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const insert = async (record) => {
    if (!isConfigured) throw new Error('Supabase no configurado.');
    const { data: result, error } = await supabase
      .from(realTableName)
      .insert(record)
      .select()
      .single();
    if (error) throw error;
    await fetchData();
    return result;
  };

  const update = async (id, record) => {
    if (!isConfigured) throw new Error('Supabase no configurado.');
    const { data: result, error } = await supabase
      .from(realTableName)
      .update(record)
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    await fetchData();
    return result;
  };

  const remove = async (id) => {
    if (!isConfigured) throw new Error('Supabase no configurado.');
    const { error } = await supabase
      .from(realTableName)
      .delete()
      .eq('id', id);
    if (error) throw error;
    await fetchData();
  };

  return { data, loading, error, refresh: fetchData, insert, update, remove };
};